<template>
  <div class="aiPanelDes ProEkran" style="height: calc(100vh - 120px)">
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="aiPanelHead">
      <p>
        <i class="el-icon-picture-outline-round text-success"></i>
        Bina Kar Analizi
      </p>
      <el-date-picker
        :clearable="false"
        @change="SayfaYukle"
        size="small"
        v-model="Tarih"
        type="daterange"
        range-separator="-"
        start-placeholder="Başlangıç Tarihi"
        end-placeholder="Bitiş Tarihi"
        format="dd.MM.yyyy"
      >
      </el-date-picker>
    </div>
    <el-table
      class="table-xs yazdirma"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="Liste"
      show-summary
      :summary-method="TableFooter"
      :height="Height">
      <el-table-column
        prop="Bina"
        label="Bina Adı"
      >
      </el-table-column>

      <el-table-column
        prop="Kisi"
        label="Kişi"
        align="center"
        width="75">
      </el-table-column>
      <el-table-column
        prop="Mesken"
        label="Mesken"
        align="center"
        width="75">
      </el-table-column>

      <el-table-column
        prop="Icra"
        label="İcra"
        align="center"
        width="75">
      </el-table-column>
      <el-table-column
        prop="Zam"
        label="Zam"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Kategori"
        label="Kategori"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Toplam"
        label="Toplam"
        align="right"
        width="100">
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      Tarih: [],
      lo: false,
      Liste: null,
      AltToplam: null,
      Height:null
    }
  },
  methods: {
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Post", {Tarih: this.Tarih, path: '_sim/binaanaliz'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.AltToplam = response.AltToplam;
            this.Liste = response.Data;
            this.Height = window.innerHeight - 170
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    TableFooter() {
      const sums = [];

      sums[3] = this.AltToplam.Icra;
      sums[1] = this.AltToplam.Kisi;
      sums[2] = this.AltToplam.Mesken;
      sums[4] = this.AltToplam.Zam;
      sums[5] = this.AltToplam.Kategori;
      sums[6] = this.AltToplam.Toplam;


      return sums;
    },
  },
  created() {
    var Gun = new Date();
    this.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sim/Comp/BinaAnaliz.vue